// menu-toggle.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuToggleService {
  private isSideNavOpenSubject = new BehaviorSubject<boolean>(false);
  isSideNavOpen$ = this.isSideNavOpenSubject.asObservable();

  toggleSideNav() {
    const currentState = this.isSideNavOpenSubject.value;
    this.isSideNavOpenSubject.next(!currentState);
  }
}
